import { ChecklistReportStore } from './checklist-report-store';
import { ChecklistMetricsStore } from './checklist-metrics-store';

export function setupRepositories(storeBuilder) {
  storeBuilder.addRepository(new ChecklistReportStore());
  storeBuilder.addRepository(new ChecklistMetricsStore());
}
